import Helpers from "./helpers";

export default class ListExpander {

	private currentElement: HTMLElement;
	private toggleButton: HTMLButtonElement;
	private limit: number;
	private moreText = 'Show More';
	private lessText = 'Show Less';
	private openClass = 'is-open';

	constructor(currentElement: HTMLElement, limit: number) {

		this.currentElement = currentElement;
		this.limit = limit;

		this.setupListExpander();
		
	}

	private setupListExpander() {
		const containerId = 'list-' + Helpers.guid();
		this.currentElement.setAttribute('aria-expanded', 'false');
		this.currentElement.setAttribute('id', containerId);
		this.toggleButton = this.currentElement.parentNode.querySelector('.js-list-expander-toggle');
		this.hideListItemsOverLimit();
		if (this.toggleButton) {
			this.toggleButton.setAttribute('aria-controls', containerId);
			this.toggleButton.addEventListener('click', (e) => this.handleToggleClick(e));
		}
	}

	private handleToggleClick(e: Event) {
		const currentTarget = e.target as HTMLButtonElement;

		if (this.currentElement.getAttribute('aria-expanded') === 'true') {
			this.hideListItemsOverLimit();
			this.currentElement.setAttribute('aria-expanded', 'false');
			currentTarget.textContent = this.moreText;
			currentTarget.classList.remove(this.openClass);
		} else {
			this.showAllListItems();
			this.currentElement.setAttribute('aria-expanded', 'true');
			currentTarget.textContent = this.lessText;
			currentTarget.classList.add(this.openClass);
			if (Helpers.isUsingKeyboard()) {
				this.focusOnFirstNewItem();
			}
		}
	}

	private hideListItemsOverLimit() {
		const listItems = this.currentElement.querySelectorAll('li');
		for (let i = 0; i < listItems.length; i++) {
			if (i + 1 > this.limit) {
				listItems[i].classList.add('u-hide');
			}
		}
	}

	private showAllListItems() {
		const listItems = this.currentElement.querySelectorAll('li');
		for (let i = 0; i < listItems.length; i++) {
			listItems[i].classList.remove('u-hide');
		}
	}

	private focusOnFirstNewItem() {
		const firstNewListItem = this.currentElement.querySelectorAll('li a')[this.limit] as HTMLLinkElement;
		if (firstNewListItem) {
			firstNewListItem.focus();
		}
	}

}

const possibleListExpanders = document.querySelectorAll('.js-list-expander');
for (let i = 0; i < possibleListExpanders.length; i++) {

	const currentElement = possibleListExpanders[i] as HTMLElement;
	const limit = parseInt(currentElement.getAttribute('data-list-expander-limit'));

	if (currentElement.querySelectorAll('li').length > limit) {
		new ListExpander(currentElement, limit);
	}

}
